import { render, staticRenderFns } from "./MdTableTypeOfBill.vue?vue&type=template&id=656ce47a&"
import script from "./MdTableTypeOfBill.vue?vue&type=script&lang=js&"
export * from "./MdTableTypeOfBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports